import Vue from 'vue';
import Router from 'vue-router';
const Login = () => import('./views/login/login.vue');
const Template = () => import('./views/template/template.vue');
import TemplateRouterChildren from './views/template/template.router';

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },

    {
      path: '/template',
      name: 'template',
      component: Template,
      children: TemplateRouterChildren,
    },

  ],
});

export default router;
